import Vue from 'vue/dist/vue.min.js';
import VModal from 'vue-js-modal';
import EventBus from './event-bus';
// import { contactModal } from "./modals";

const ContactUs = () => {
    Vue.use(VModal);

    Vue.component('contact-us', {
        props: ['contactOpen'],
        methods: {
            toggleModal() {
                EventBus.$emit('close-contact');

                // this.$modal.show(
                //     contactModal.template,
                //     contactModal.name,
                //     contactModal.options,
                //     contactModal.events
                // )
            },
        },
        mounted() {
        }
    });

}

export default ContactUs;